// Sanahaku nimike-, työmaa- ja kalustovalintoihin sekä Nimikkeet-näkymään: jokaisen hakusanan on löydyttävä
// tekstistä, järjestyksellä ei ole väliä. Pilkku ja piste rinnastetaan (323.9 löytää 323,9).

const normalize = text => (text || '').toLowerCase().replace(/,/g, '.');

export const searchWords = search => normalize(search).split(/\s+/).filter(Boolean);

export function matchesWords(text, words) {
  const normalized = normalize(text);
  return words.every(word => normalized.includes(word));
}
